// dependencies
import * as Sentry from "@sentry/react";
import { fromJS } from "immutable";

export default {
	error: (response) => {
		const { data } = response; // data, request, status, succeeded
		let parseData = {};

		try {
			parseData = fromJS(data);
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			parseData = {};
		}

		return parseData;
	},
};
